import React from 'react';
import MyLanguages from './MyLanguages';

class MiniBio extends React.Component {
  constructor() {
    super();
    this.state = {
      longText: "hidden",
      dots: "display:flex",
      buttonText: "Read more...",
    };
  }

  expandText = () => {
    console.log('fjaçldjfaçlkdj');
    this.setState({ longText: "hidden" });
  }

  render() {
    const intro = `
      Tenho comprometimento com o espírito de integração, agregação e geração de valor. Sou uma pessoa criativa, organizada e focada, com capacidade de adaptação. Estou retomando minha carreira como programador, agora com foco em Desenvolvimento Web. Ao longo dos anos acumulei experiências profissionais diversas na área administrativa, cooperando para a pequena empresa familiar - nos ramos de calçados e produtos eletrônicos - Sou naturalmente curioso sobre novidades e tecnologia, além disso, gosto de jardinagem, música e história. E levo uma vida tranquila no interior do estado de Minas Gerais. 

Entre as tecnologias que domino destaco NodeJS, e a linguagem TypeScript, onde consigo trabalhar tanto com FrontEnd em React e se necessário na construção do BackEnd. Tenho experiência com banco de dados relacionais e familiaridade com SQL. E também atuo como DevOps em meus próprios projetos, que são páginas LandingPages diversas e um sistema de gerenciamento de clientes para uma empresa localizada em Uberlândia. (veja mais nas descrições - ReadMe - dos projetos destacados - pinados - no meu perfil do Github)

No que acho interessante destacar dentro da minha formação: Cursei o ciclo básico de bacharelado em Ciência da Computação - Universidade Federal de Uberlândia(UFU), em 2006, e também cursei Desenvolvimento Fullstack na escola de programação Trybe, concluído em 2022, onde tivemos mais de 1500 horas de formação, distribuídas entre estudo de conteúdo, aulas ao vivo, projetos individuais e em grupo e desenvolvimento de habilidades socioemocionais(softskills).
    `
    const presentation1 = `Trabalho com NodeJS, e 
    linguagem TypeScript, onde consigo desenvolver tanto em FrontEnd com React e 
    se necessário na construção do BackEnd. Tenho experiência com banco de dados 
    relacionais e familiaridade com SQL. E também atuo como DevOps em meus 
    próprios projetos, que são páginas LandingPages diversas e um sistema 
    de gerenciamento de clientes para uma empresa localizada em Uberlândia. 
    (veja mais em meu Github)
    `
    // const presentation1 = `
    //   Fast forward to 2021, I went hard into web development,
    //   learning Front End and Back End stacks through more than 30
    //   projects that I have coded for learning sake: From fundamentals
    //   HTML & CSS to JavaScript React, including tests and CRUD 
    //   using Node.js + Express. I'm also into Agile Methodologies and
    //   teamwork cooperations.  `

    const curiosity = ` No que acho interessante destacar dentro da minha formação: Cursei o ciclo básico de bacharelado em Ciência da Computação - Universidade Federal de Uberlândia (UFU), em 2006, e também cursei Desenvolvimento Fullstack na escola de programação Trybe, concluído em 2022, onde tivemos mais de 1500 horas de formação, distribuídas entre estudo de conteúdo, aulas ao vivo, projetos individuais e em grupo e desenvolvimento de habilidades socioemocionais (softskills).
    `
    // const curiosity = `
    //   Some random curiosities about me: I like music and already 
    //   played in a rock band. 
    //   I'm also on gardening as a way to do concrete things 
    //   away from a computer screen. So, let's talk about world history or 
    //   3D printter cool projects and possibilities? Or maybe just play GTA V
    //   role play and talk about how metaverse is reality and future. If I'm 
    //   working on this today it is because I believe in the disruptive force of
    //   new technologies. For me, being a dev is more than a career, it's a life 
    //   long experience to understand and apply abstractions of real-material
    //   world within binary logic.
    // `
    const { dots, longText, buttonText } = this.state;
    return (
      <div className="">
        <div className=''>
          <h2 className='text-lime-300 lg:text-[36px] md:text-[33px] sm:text-[30px] text-[22px] sm:py-6 py-3'>
            Desenvolvedor de Software
          </h2>
        </div>
        <hr className='opacity-60 py-2' />
        <p className='leading-normal pt-3 sm:py-5 text-[23px] font-serif'>
        Tenho comprometimento com o espírito de integração, 
        agregação e geração de valor. Sou uma pessoa criativa, organizada e focada, 
        com capacidade de ad
          <span className={dots}>...</span>
          <span id="more" className={longText}>
          aptação. Estou retomando minha carreira como programador, agora com foco em Desenvolvimento Web. 
          Ao longo dos anos acumulei experiências profissionais diversas na área administrativa, 
          cooperando para a pequena empresa familiar - nos ramos de calçados e produtos eletrônicos - 
          Sou naturalmente curioso sobre novidades e tecnologia, além disso, gosto de jardinagem, música e história. 
          E levo uma vida tranquila no interior do estado de Minas Gerais.
          </span>
        </p>


        {/* <p className='leading-normal py-3 text-[23px] font-serif'>{intro}</p> */}
        <p className={`leading-normal py-3 text-[23px] font-serif ${longText}`}>{presentation1}</p>
        <p className={`leading-normal py-3 text-[23px] font-serif ${longText}`}>{curiosity}</p>


        <button
          className='opacity-60 py-2 container'
          enabled="true"
          type="button"
          onClick={() => {
            if (longText === 'display:flex') {
              this.setState({ dots: "display:flex", longText: "hidden", buttonText: "Read more..." })
            }
            else this.setState({ dots: "hidden", longText: "display:flex", buttonText: "Read less..." });
          }}
        >
          {buttonText}
        </button>

        <p className='pt-5 sm:py-7 lg:text-5xl md:text-4xl text-3xl'>
          {`Languages & tools`}
        </p>
        <MyLanguages />

      </div>
    );
  }
}

export default MiniBio;